import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';

export default function ScrollToTopButton() {
    const [isVisible, setIsVisible] = useState(false);
  
    // Show button when page is scrolled down
    const toggleVisibility = () => {
      if (window.scrollY > 50) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
  
    // Guaranteed smooth scroll implementation
    const scrollToTop = () => {
      // Get the current scroll position
      const currentPosition = window.pageYOffset;
      if (currentPosition === 0) return; // Already at top
      
      // Animation settings
      const duration = 800; // ms - increase for slower scroll
      const startTime = performance.now();
      
      // Create animation frame
      function animateScroll(timestamp) {
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        // Easing function - easeOutCubic
        const easeProgress = 1 - Math.pow(1 - progress, 3);
        
        // Calculate new position and scroll to it
        const newPosition = currentPosition - (currentPosition * easeProgress);
        window.scrollTo(0, newPosition);
        
        // Continue animation if not done
        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      }
      
      // Start the animation
      requestAnimationFrame(animateScroll);
    };
  
    useEffect(() => {
      window.addEventListener('scroll', toggleVisibility);
      
      // Clean up the event listener
      return () => {
        window.removeEventListener('scroll', toggleVisibility);
      };
    }, []);

    return (
      <>
        {isVisible && (
          <button
            onClick={scrollToTop}
            className="scroll-to-top-btn"
            aria-label="Scroll to top"
          >
            <FaArrowUp color='white' size={18}/>
          </button>
        )}
      </>
    );
}